import React, { createContext, useContext, useMemo, useState } from "react";

const DynamicPanelContext = createContext(null);

export function DynamicPanelProvider({ children }) {
  const [gamePanelData, setGamePanelData] = useState(null);

  const value = useMemo(
    () => ({
      gamePanelData,
      setGamePanelData,
    }),
    [gamePanelData]
  );

  return (
    <DynamicPanelContext.Provider value={value}>
      {children}
    </DynamicPanelContext.Provider>
  );
}

export function useDynamicPanel() {
  const ctx = useContext(DynamicPanelContext);
  if (!ctx) {
    throw new Error("useDynamicPanel must be used within a DynamicPanelProvider");
  }
  return ctx;
}

